import { render, staticRenderFns } from "./ProgramAdminDataTable.vue?vue&type=template&id=606f4df8&scoped=true"
import script from "./ProgramAdminDataTable.vue?vue&type=script&lang=js"
export * from "./ProgramAdminDataTable.vue?vue&type=script&lang=js"
import style0 from "./ProgramAdminDataTable.vue?vue&type=style&index=0&id=606f4df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f4df8",
  null
  
)

export default component.exports